/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/alt-text */
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { NavbarBottomAdmin, NavbarTopAdmin } from '../admin/components'
import { Luoghi, App, ImgRandomEventi, DivBottom, BarraAggiungiEvento, NavbarNotAuth, SliderEventi, Slider } from './components'

function Home() {
    const [event, setEvent] = useState({})
    const [cont, setCont] = useState(12)//numero iniziale di eventi da visualizzare 

    const month = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"]
    const d = new Date()
    const mese = month[d.getMonth()]; const meseNumber = d.getMonth()

    const today = new Date(); const todayForCompare = new Date().toISOString()
    today.setDate(today.getDate() - 1) //tolgo un giorno alla data odierna
    const tomorrow = new Date(today).toISOString()//valorizzo tomorrow con la data di domani

    const [fotoDaScegliere, setFotoDaScegliere] = useState()

    function mostraPiu() { setCont(event.length) }

    useEffect(() => {//numero di eventi iniziali
        if (event.length > 1) {//devisualizzo gli eventi 
            for (let i = cont + 1; i <= event.length; i++) {
                document.getElementById(i + 'card').style.display = 'none'

            }
            for (let i = 1; i <= cont; i++) {//visualizzo gli  eventi
                if (i <= event.length) {
                    document.getElementById(i + 'card').style.display = 'block'
                }
            }
        }
    }, [event, cont])

    useEffect(() => {
        async function getEvent() {
            try {
                let response = await axios.get('/getEventi/dataInizio')
                const eventiSenzaIeri = response.data.toReversed().filter(x => !(x.dataFine < tomorrow))
                eventiSenzaIeri.forEach(element => {
                    if (element.img) element.img = element.img.split(',')//da stringa ad array
                })
                setEvent(eventiSenzaIeri
                    .filter(item => (item.accettazione !== 'rejection'))
                    .filter(item => (item.accettazione !== 'false'))
                )
            } catch (err) { console.error(err) }
        }
        getEvent()
        const vbn = document.getElementById('preCarCard')
        setTimeout(() => { vbn.style.opacity = '0' }, 400)
        setTimeout(() => { vbn.style.display = 'none' }, 1000)
    }, [])
    return (<>
        <ImgRandomEventi onDataSubmit={(e) => { setFotoDaScegliere(e) }} />
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div style={{ marginTop: '5rem' }} id='top'>
            <div className='container-fluid'>
                <p >\<b>Home</b></p>
            </div>

            <App />
            <BarraAggiungiEvento />
            <SliderEventi /> <Slider />

            <div style={{ backgroundColor: 'ghostwhite', borderTop: '1px solid lightgrey', borderBottom: '1px solid lightgrey', marginTop: '1em' }}>
                <h5 className='mt-5' style={{ textAlign: 'center', fontFamily: 'sans-serif' }}>
                    ⇓ <b>EVENTI DI {mese.toUpperCase()}</b> ⇓
                </h5><br />

                {/* ------------------------------ DIV PER VIEW DI PRECARICAMENTO CARD OVERFLOW -------------------------- */}
                <div id='preCarCard' className='preCarCard' style={{ transition: 'opacity 1s' }}>
                </div>

                <div style={{ overflow: 'auto', whiteSpace: 'nowrap', overflowY: 'hidden' }}>
                    {event.length > 0 && event
                        .filter(item => (new Date(item.dataFine).getMonth() >= (meseNumber - 1) && new Date(item.dataInizio).getMonth() <= (meseNumber)))
                        .reverse().map((evento, index) => {
                            const itemScelto = fotoDaScegliere.find(item => item.tipologia === evento.tipologia)
                            let fotoScelta
                            if (itemScelto && !evento.img) {
                                const arrayFoto = itemScelto.foto; // Prende l'array di foto corretto
                                const indiceCasuale = Math.floor(Math.random() * arrayFoto.length)
                                fotoScelta = arrayFoto[indiceCasuale]
                            }

                            return (
                                <Link to={`/eventiDetails/${evento.id}`} state={{ fotoScelta: fotoScelta }} style={{ textDecoration: 'none', color: 'black' }} key={evento.id}>
                                    <div className="scrollmenu_article">
                                        {evento.img[0] ? //foto inserita dall'utente
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${evento.img[0]}`} width={282} height={230} className='rounded'
                                                style={{ objectFit: 'cover' }} />
                                            : //foto scelta a caso da AWS
                                            fotoScelta ? <img src={`https://leuro-bucket.s3.amazonaws.com/imgRandomEventi/${fotoScelta}`} width={282} height={230} className='rounded'
                                                style={{ objectFit: 'cover' }} />
                                                :
                                                <img src={`https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg`} width={282} height={230} className='rounded' />
                                        }
                                        <p style={{
                                            margin: '3px 0px 0px 3px', backgroundColor: 'beige', borderBottom: '1px solid silver',
                                            textAlign: 'center', fontWeight: '700', fontSize: '14px'
                                        }}>{evento.titolo.length > 38 ? <span>{evento.titolo.slice(0, 37)}...</span> : evento.titolo
                                            }
                                        </p>
                                        <p style={{ margin: '10px 3px', fontFamily: 'sans-serif' }}>{evento.città} ({evento.provincia})</p>
                                        <p style={{ margin: '0px 3px' }}>{evento.dataInizio.split("-").reverse().join("-")}
                                            {evento.dataFine !== evento.dataInizio &&
                                                <span> ⇾ {evento.dataFine.split("-").reverse().join("-")}</span>
                                            }
                                        </p>
                                        {todayForCompare >= evento.dataInizio === true && tomorrow <= evento.dataFine === true && evento.accettazione === 'true' ?
                                            <p className='ms-1 text-success float-start'>
                                                <b>in corso</b>
                                            </p>
                                            : evento.accettazione === 'null' ? <p className='ms-1 float-start'><b>ANNULLATO</b></p> : ''
                                        }
                                        <span style={{
                                            float: 'right', backgroundColor: 'maroon', borderRadius: '5px', padding: '3px',
                                            color: 'azure', opacity: '.7', marginRight: '3px'
                                        }}>
                                            {evento.tipologia}
                                        </span>
                                    </div>
                                </Link>
                            )
                        }
                        )}
                </div>
                <div style={{ height: '2em' }}></div>
            </div>

            {/* ------------------------------------ DIV CARICA IL TUO EVENTO ---------------------------- */}
            <div className='text-center mt-5'>
                <a className='btn btn-primary' href="/addEvento"><b>⇒ Carica il tuo Evento ⇐</b></a>
            </div>

            <div className='container' style={{ marginTop: '3rem' }}>
                <h3 className='text-center'>DOVE ANDARE...COSA FARE</h3>
                <p style={{ opacity: '0.7', textAlign: 'center' }}>EVENTI IN ITALIA</p>
            </div>
            <div className='homePadding'>
                <div className='row' style={{ marginTop: '-2rem' }}>
                    {event.length > 0 && event.map((card, index) => {
                        const itemScelto = fotoDaScegliere.find(item => item.tipologia === card.tipologia)
                        let fotoScelta
                        if (itemScelto && !card.img) {
                            const arrayFoto = itemScelto.foto; // Prende l'array di foto corretto
                            const indiceCasuale = Math.floor(Math.random() * arrayFoto.length)
                            fotoScelta = arrayFoto[indiceCasuale]
                        }
                        return (
                            <div key={card.id} className="card mt-5" id={(index + 1) + 'card'}
                                style={{
                                    width: '26rem', height: '100%',
                                    padding: '0px',
                                    margin: '0 auto',
                                    border: '3px solid gainsboro',
                                }}>
                                <Link to={{ pathname: `/eventiDetails/${card.id}` }} state={{ fotoScelta: fotoScelta }} style={{ textDecoration: 'none', color: 'black' }}>
                                    {card.img[0] ?
                                        <img src={`https://leuro-bucket.s3.amazonaws.com/${card.img[0]}`} width='100%' height={300} className='rounded' alt=''
                                            style={{ objectFit: 'cover' }} />
                                        : //foto scelta a caso da AWS
                                        fotoScelta ? <img src={`https://leuro-bucket.s3.amazonaws.com/imgRandomEventi/${fotoScelta}`} width='100%' height={300} className='rounded'
                                            style={{ objectFit: 'cover' }} />
                                            :
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg`} width='100%' height={300} className='rounded' alt='' />
                                    }
                                    <div className="card-body">
                                        <p className="card-title text-center"><b>{card.titolo}</b></p>
                                        <p className="card-text" style={{ fontWeight: '500', marginTop: '-10px' }}>{card.città} ({card.provincia})</p>
                                        <p className="card-text" style={{ marginTop: '-12px' }}>
                                            <span>{card.dataInizio.split("-").reverse().join("-")}</span>
                                            {card.dataInizio !== card.dataFine &&
                                                <span> ⇾ {card.dataFine.split("-").reverse().join("-")}</span>
                                            }
                                        </p>

                                        <p style={{ fontSize: 'small', marginTop: '-15px' }}><i>View: {card.view}</i></p>
                                        <div style={{ marginTop: '-15px' }}>
                                            {todayForCompare >= card.dataInizio === true && tomorrow <= card.dataFine === true && card.accettazione === 'true' ?
                                                <p className='text-success d-inline'>
                                                    <b>in corso</b>
                                                </p> : card.accettazione === 'null' ?
                                                    <p className='ms-1'><b>ANNULLATO</b></p>
                                                    : <img src={require('./image/icons8-messaggio-di-chat-50.png')} width={25} alt='' />
                                            }
                                            <p style={{ float: 'right' }}>

                                                <span style={{
                                                    backgroundColor: 'maroon', padding: '3px', color: 'azure', opacity: '.7', fontSize: 'small', borderRadius: '5px',
                                                }}>
                                                    {card.tipologia}
                                                </span>
                                            </p>
                                        </div>
                                        {card.accettazione === 'null' &&
                                            <p style={{
                                                backgroundColor: 'black', color: 'white', padding: '3px', width: 'fit-content', margin: 'auto'
                                            }}>Annullato
                                            </p>
                                        }
                                    </div>
                                </Link>
                            </div>
                        )
                    })}
                </div>
                <div className='text-center mt-5'>
                    <button onClick={mostraPiu} className='btn btn-primary'>
                        Mostra di più
                    </button>
                    <a href="#top" style={{ marginLeft: '1rem', fontSize: 'xx-large', color: 'black' }}><b>⇑</b></a>
                </div>
            </div>
        </div>
        <Luoghi />
        <DivBottom />
    </>
    )
}
export default Home